export const environment = {
    production: false,
    //API标准格式形如：http://xxx.xxx.xxx.xxx/  （注意最后斜杠）
    //#region  seeker基础平台微服务api地址配置区域
    seekerWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-basic/",
    fileWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-file/",
    activitiWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-activiti/",
    scheduleWebApi: "https://bjtest.cncis.com.cn:8001/g/sw-scheduler/",
    ruleWebApi: "https://bjtest.cncis.com.cn:8001/g/sw-rule/",
    webSoketApi: "ws://192.168.10.96:8000:8041/",
    outWebAPI: "http://192.168.10.96:8000:8074/",
    smsWebAPI: "http://192.168.10.96:8000:8021/",
    esWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-es/",
    saasWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-saas/",
    staticFileUrl: "https://bjtest.cncis.com.cn:8001/fileUpload/",
    onlineOfficeWebAPI: "https://bjtest.cncis.com.cn:8001/fileUpload/",
    iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",
    uploadDirectory: "",
    sendCodeUrl: "http://192.141.6.105:8021/",
    //#endregion
    //#region 智慧博物馆业务产品领域微服务api地址配置区域
    cmsWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-cms/",
    damWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-dam/",
    trmWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-trm/",
    actWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-act/",
    volWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-vve/",
    vipWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-vve/",
    expWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-vve/",
    wecWebAPI: 'https://bjtest.cncis.com.cn:8001/g/sw-cms/',
    apfWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-apf/",
    ckfWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-ckf/",
    drmWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-drm/",
    amsWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-oms/",
    dssWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-dss/",
    dpsWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-dps/",
    //#endregion
    //#region  其他业务产品领域微服务api地址配置区域
    pcrWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-pcr-zy/",
    cirWebAPI: "",
    apmWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-apm-beijing/",
    famWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-fam-beijing/",
    famPanoPrefix: "https://bjtest.cncis.com.cn:8001/",
    caAPI: "http://192.141.6.105:11001/",
    caWebsocketApi: "ws://192.141.6.105:11001/",
    apoWebAPI: "",
    proWebAPI: "",
    webSocketPcrUrl: "",
    kgsWebAPI: "http://192.168.10.97:8095/",
    mapWebAPI: "",
    rmsWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-rms",
    sesWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-ses",
    qasWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-qas",
    omsWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-oms/",
    anbWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-anb/",
    aamWebAPI: 'https://bjtest.cncis.com.cn:8001/g/sw-aam/',
    sicWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-sic/",
    rdpWebAPI: "https://bjtest.cncis.com.cn:8001/g/sw-rdp/",
    //#endregion
    //#region 项目基本属性配置区域
    encryptedPassword: false,
    multiTenancy: false,
    systemCode: 'WYS_BEIJING',
    isVcode: false,
    isSliderCode: false,
    isCA: false,
    isRelateDingTalk: false,
    dingTalkAgentId: "325262018",
    syncToUserResource: true,
    singleTab: false,
    singleMenu: false,
    openDefaultMenu: true,
    enbaleCustomLayout: false,
    hideSingleTab: "",
    tabNumber: 10,
    defaultLanguage: null,
    projectName: "智慧博物馆统一登录平台",
    customerName: "智慧博物馆",
    defaultDashboard: "/fapm/ags/GisMap",
    defaultPortal: "/fapm/ags/GisMap",
    fullScreen: "/fapm/ags/GisMap",
    enableSsoLogin: false,
    resourceMark: true,
    multiOrgWaterMark: false,
    projectLogo: "/assets/Theme/default/img/logo.png",
    projectLogoWidth: "220",
    loginStyle: 1,
    loginBackGround: "/assets/Theme/default/img/login-bg.jpg",
    favoriteIco: "/favicon.ico",
    isLoadAllMenu: true,
    ssoTokenName: "Zxy",
    coptyRight: "版权所有 © 2019-2025 &nbsp;数文科技 &nbsp; 建议浏览器：chrome/360极速浏览器" //版权相关声明
    //#endregion
};